export enum EquipmentType {
  AUTOTRANSFORMER = 'AUTOTRANSFORMER',
  BATTERY_BANK = 'BATTERY_BANK',
  BLOCKING_COIL = 'BLOCKING_COIL',
  BUSBAR = "BUSBAR",
  BUSHING = 'BUSHING',
  CAPACITOR_BANK = 'CAPACITOR_BANK',
  CAPACITIVE_DIVIDER = 'CAPACITIVE_DIVIDER',
  CAPACITIVE_POTENTIAL_TRANSFORMER = 'CAPACITIVE_POTENTIAL_TRANSFORMER',
  CIRCUIT_BREAKER = 'CIRCUIT_BREAKER',
  CURRENT_TRANSFORMER = 'CURRENT_TRANSFORMER',
  DISCONNECT_SWITCH = 'DISCONNECT_SWITCH',
  DISTRIBUTION_LINE = 'DISTRIBUTION_LINE',
  ELECTRICAL_PANEL = 'ELECTRICAL_PANEL',
  FUSE_SWITCH = 'FUSE_SWITCH',
  GENERATOR = 'GENERATOR',
  EMERGENCY_GENERATOR = 'EMERGENCY_GENERATOR',
  INDUCTIVE_POTENTIAL_TRANSFORMER = 'INDUCTIVE_POTENTIAL_TRANSFORMER',
  METAL_CLAD_SWITCHGEAR = 'METAL_CLAD_SWITCHGEAR',
  POTENTIAL_TRANSFORMER = 'POTENTIAL_TRANSFORMER',
  POWER_TRANSFORMER = 'POWER_TRANSFORMER',
  PROTECTION_CONTROL_PANEL = 'PROTECTION_CONTROL_PANEL',
  PROTECTION_SYSTEM = 'PROTECTION_SYSTEM',
  RECTIFIER = 'RECTIFIER',
  RELAY = 'RELAY',
  SERIES_COMPENSATOR = 'SERIES_COMPENSATOR',
  SHUNT_REACTOR = 'SHUNT_REACTOR',
  STATIC_COMPENSATOR = 'STATIC_COMPENSATOR',
  SURGE_ARRESTER = 'SURGE_ARRESTER',
  SYNCHRONOUS_CONDENSER = 'SYNCHRONOUS_CONDENSER',
  TRANSMISSION_TOWER = 'TRANSMISSION_TOWER'
}

